import { Component, Injectable, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { StorageService } from 'src/app/services/storage.service';

import { User } from 'src/app/interfaces/user';
import { Plan } from 'src/app/interfaces/plan';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  selector: 'app-plan-create-modal',
  templateUrl: './plan-create-modal.component.html',
  styleUrls: ['./plan-create-modal.component.scss'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class PlanCreateModalComponent implements OnInit {
  planForm: UntypedFormGroup;
  plans!: Plan[];
  planData?: {
    userId: number;
    planId: number;
    weeks: number;
  };

  jsPlanStart: Date | undefined;
  user!: User;
  selectedFinishType: 'date' | 'weeks' = 'weeks';
  today?: dayjs.Dayjs;

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private toastService: ToastService,
    private storageService: StorageService
  ) {
    this.planForm = this.fb.group({
      planType: [null, [Validators.required]],
      weeks: [12, [Validators.required]],
    });
  }

  ngOnInit(): void {
    dayjs.extend(utc);
    this.today = dayjs.utc();

    this.planData = {
      userId: 0,
      planId: 0,
      weeks: 0,
    };

    this.getPlans();
  }

  createPlan(): void {
    this.user = this.storageService.get('selectedUser');
    this.planData!.userId = this.user.id!;

    const planIdString = (this.planData!.planId + '') as string;

    this.planData!.planId = parseInt(planIdString);

    this.planData!.weeks = parseInt(this.weeks.value);

    this.userService.createPlan(this.planData!).subscribe({
      next: () => {
        this.toastService.success('Se creó con éxito tu plan.');
        location.reload();
      },
      error: () => {
        this.toastService.alert('No se creó con éxito tu plan.');
      },
    });
  }

  getPlans(): void {
    this.userService.getPlans().subscribe({
      next: (plans: Plan[]) => {
        this.plans = plans;
      },
    });
  }

  switchFinishAt(type: 'date' | 'weeks'): void {
    this.selectedFinishType = type;
  }

  selectPlanType(): void {
    this.planData!.planId = this.planType.value;
  }

  returnWith0(number: string | number): string {
    return ('0' + number).slice(-2);
  }

  get planType(): AbstractControl {
    return this.planForm.controls['planType'];
  }

  get planStart(): AbstractControl {
    return this.planForm.controls['planStart'];
  }

  get planFinish(): AbstractControl {
    return this.planForm.controls['planFinish'];
  }

  get weeks(): AbstractControl {
    return this.planForm.controls['weeks'];
  }
}
